/* Arbove — Révélation de titre lettre par lettre (fade + slide up).
   Vanilla JS + CSS transitions, zéro lib. S'applique à [data-reveal="letters"] ou .reveal-letters.
   - Split propre : mots insécables (.split-word) puis lettres (.split-letter).
   - Déclenché à l'entrée dans le viewport (IntersectionObserver), une seule fois.
   - Accessible : heading garde son texte (aria-label complet), lettres en aria-hidden.
   - prefers-reduced-motion : aucune animation, texte affiché tel quel.
   - Progressive enhancement : sans JS, le titre est simplement visible. */
(function () {
  if (window.__arReveal) return;
  window.__arReveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitEl(el) {
    if (el.dataset.rlDone) return;
    el.dataset.rlDone = '1';

    var raw = el.textContent;
    var full = raw.replace(/\s+/g, ' ').trim();
    if (!full) return;

    // Le lecteur d'écran lit le titre entier d'un coup
    el.setAttribute('aria-label', full);

    var stagger = parseInt(el.dataset.revealStagger, 10);
    if (isNaN(stagger)) stagger = 25;
    var distance = el.dataset.revealDistance || '0.6em';
    var duration = el.dataset.revealDuration || '0.7s';

    var letterCount = full.replace(/\s/g, '').length;
    var byWord = letterCount > 80; // perf : au-delà de ~80 lettres, on anime par mot

    var tokens = raw.split(/(\s+)/); // conserve les espaces
    var inner = document.createElement('span');
    inner.className = 'rl-inner';
    inner.setAttribute('aria-hidden', 'true');

    var idx = 0;
    for (var t = 0; t < tokens.length; t++) {
      var token = tokens[t];
      if (token === '') continue;
      if (/^\s+$/.test(token)) {
        inner.appendChild(document.createTextNode(' '));
        continue;
      }
      var word = document.createElement('span');
      word.className = 'split-word';
      if (byWord) {
        var wu = document.createElement('span');
        wu.className = 'split-letter';
        wu.style.transitionDelay = (idx * stagger) + 'ms';
        wu.textContent = token;
        word.appendChild(wu);
        idx++;
      } else {
        for (var i = 0; i < token.length; i++) {
          var l = document.createElement('span');
          l.className = 'split-letter';
          l.style.transitionDelay = (idx * stagger) + 'ms';
          l.textContent = token.charAt(i);
          word.appendChild(l);
          idx++;
        }
      }
      inner.appendChild(word);
    }

    el.textContent = '';
    el.appendChild(inner);
    el.style.setProperty('--rl-distance', distance);
    el.style.setProperty('--rl-duration', duration);
    el.__rlUnits = idx;
    el.__rlStagger = stagger;
  }

  function reveal(el) {
    el.classList.add('rl-active');
    el.classList.add('is-revealed');
    // retire will-change une fois l'animation terminée
    var total = (el.__rlUnits || 1) * (el.__rlStagger || 25) + 900;
    setTimeout(function () { el.classList.remove('rl-active'); }, total);
  }

  function init() {
    var els = document.querySelectorAll('[data-reveal="letters"], .reveal-letters');
    if (!els.length) return;

    // Reduced motion : on ne touche à rien, le titre reste net et lisible
    if (reduce) return;

    for (var i = 0; i < els.length; i++) splitEl(els[i]);

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < els.length; j++) reveal(els[j]);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
